import {
  ConsolidatedBudgetFilters,
  ConsolidatedEvolutionFilters,
  getEvolution,
  list,
  listByBudgetTemplateAndType,
  listByCostCenter,
  listByMonthAndCategory,
  pin,
  unpin,
} from './calls';

export * from './calls';

export default class ConsolidatedBudgetAPICaller {
  static list = async (filters: ConsolidatedBudgetFilters) => {
    const {
      data: { consolidatedBudgets },
    } = await list(filters);

    return consolidatedBudgets;
  };

  static listCostCenterBudget = async (filters: ConsolidatedBudgetFilters) => {
    const {
      data: { consolidatedBudgets },
    } = await listByCostCenter(filters);

    return consolidatedBudgets;
  };

  static listCostCenterBudgetMonthAndCategory = async (
    filters: ConsolidatedBudgetFilters & { categoryId: string }
  ) => {
    const {
      data: { consolidatedBudgets },
    } = await listByMonthAndCategory(filters);

    return consolidatedBudgets;
  };

  static listReportByBudgetTemplateAndType = async (
    filters: ConsolidatedBudgetFilters
  ) => {
    const {
      data: { report },
    } = await listByBudgetTemplateAndType(filters);

    return report;
  };

  static getEvolutionData = async (filters: ConsolidatedEvolutionFilters) => {
    const {
      data: { evolution },
    } = await getEvolution(filters);

    return evolution;
  };

  static pinCategory = async (
    budgetTemplateId: string,
    costCenterId: string,
    categoryId: string
  ) => {
    return pin({ budgetTemplateId, costCenterId, categoryId });
  };

  static unpinCategory = async (
    budgetTemplateId: string,
    costCenterId: string,
    categoryId: string
  ) => {
    return unpin({ budgetTemplateId, costCenterId, categoryId });
  };
}
